var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          attrs: {
            title: "农信平台用户协议",
            visible: _vm.visible,
            width: "70%",
            center: ""
          },
          on: {
            "update:visible": function($event) {
              _vm.visible = $event
            }
          },
          scopedSlots: _vm._u([
            {
              key: "footer",
              fn: function() {
                return [
                  _c(
                    "span",
                    { staticClass: "dialog-footer" },
                    [
                      _c("el-button", { on: { click: _vm.agreement } }, [
                        _vm._v("取 消")
                      ]),
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary" },
                          on: { click: _vm.agreement }
                        },
                        [_vm._v("确 定")]
                      )
                    ],
                    1
                  )
                ]
              },
              proxy: true
            }
          ])
        },
        [
          _c(
            "div",
            {
              staticClass: "amap-page-container",
              staticStyle: { "max-height": "380px", overflow: "auto" }
            },
            [
              _c("div", { staticClass: "pop_con pad20 f14" }, [
                _c("div", { staticClass: "clearfix gray_6" }, [
                  _c("ul", { staticClass: "yo-list line_h25" }, [
                    _c("li", { staticClass: "item" }, [
                      _vm._v(
                        '\n              本协议是您与农信网站（简称"本网站"，网址：www.nxin.com）所有者（以下简称为"农信互联"）\n              之间就农信网站服务等相关事宜所订立的契约，在您注册成为本网站用户前请务必仔细阅读以下条款。\n              若您一旦注册，则表示您同意接受本网站的服务并受以下条款的约束；若您不接受以下条款， 请您立即停止注册或主动停止使用本网站的服务。\n            '
                      )
                    ]),
                    _c("li", { staticClass: "item" }, [_vm._v("一、注册条件")]),
                    _c("li", { staticClass: "item" }, [
                      _vm._v(
                        "\n              注册为本协议用户的个人主体的条件：持有中国有效身份证明的18周岁以上具有完全民事行为能力的自然人。\n              如您不符合资格，请勿注册，否则本网站有权随时中止或终止您的用户资格。\n            "
                      )
                    ]),
                    _c("li", { staticClass: "item" }, [
                      _vm._v("二、本协议组成部分及签署和修订")
                    ]),
                    _c("li", { staticClass: "item" }, [
                      _vm._v(
                        "\n              1、本协议的组成部分：包括但不限于本协议全全部条款及本网站已经或将来可能发布的各类规则。\n              本协议是您与本网站共同签订的，适用于您在本网站的全部活动，您在本网站的全部行为所产生的权利、 义务及法律责任均由您自行承担。"
                      ),
                      _c("br"),
                      _vm._v(
                        "\n              2、本网站有权根据需要不时地修改本协议或根据本协议制定、修改各类具体规则并在本网站相关系统板块发布，\n              无需另行单独通知您。若您在本协议及具体规则内容公告变更后继续使用本服务的，\n              表示您已充分阅读、理解并接受修改后的协议和具体规则内容，也将遵循修改后的协议和具体规则使用本网站的服务；\n              同时就您在协议和具体规则修订前通过本网站进行的交易及其效力， 视为您已同意并已按照本协议及有关规则进行了相应的授权和追认\n              （新修订的协议与具体规则不要求授权与追认的除外）。 若您不同意修改后的协议内容，您应停止使用本网站的服务。"
                      ),
                      _c("br"),
                      _vm._v(
                        "\n              3、您通过自行或授权有关方根据本协议及本网站有关规则、说明操作确认本协议后， 本协议即在您和本网站之间产生法律效力。\n            "
                      )
                    ]),
                    _c("li", { staticClass: "item" }, [
                      _vm._v("三、网站服务内容及使用要求")
                    ]),
                    _c("li", { staticClass: "item" }, [
                      _vm._v(
                        "\n              1、本网站提供的服务包括但不限于：发布行情信息、提供贷款平台、发布借款需求、\n              查阅交易机会、签订和查阅合同、资金充值、提现、代收、代付等，具体以本网站当时提供的服务内容或产品为准。"
                      ),
                      _c("br"),
                      _vm._v(
                        "\n              2、基于运行和交易安全的需要，本网站可以暂时停止提供、限制或改变本网站服务的部分功能，\n              或提供新的功能。如您在上述改变发生后仍然使用本网站的服务，表示您已经同意上述改变。"
                      ),
                      _c("br"),
                      _vm._v(
                        "\n              3、在您成功注册后，您可以自行或授权您的代理人根据本网站有关规则和说明， 通过本网站确认签署有关协议、申请有关产品或服务、进行各种交易，\n              通过您注册的账号进行的上述操作或交易均视为您本人或经您本人合法授权的代理人做出， 由此产生的相应权利义务，均由您本人承接。"
                      ),
                      _c("br"),
                      _vm._v(
                        "\n              4、您确认，您在本网站上按本网站服务流程所确认的交易状态将成为本网站为您进行相关交易或操作\n              （包括但不限于冻结资金、代为支付或收取款项、订立合同等）的明确指令。\n              您同意本网站有权按相关指令依据本协议和/或有关文件和规则对相关事项进行处理。"
                      ),
                      _c("br"),
                      _vm._v(
                        "\n              5、因您未及时提交相关申请或对交易状态进行修改或确认所引起的任何纠纷或损失由您本人负责， 本网站不承担任何责任。"
                      ),
                      _c("br"),
                      _vm._v(
                        "\n              6、您在此同意将全面接受和履行与本网站其他主体（含服务或商品经营者等用户）\n              在本网站签订的任何电子法律文本，并承诺按该等法律文本享有和/或放弃相应的权利、承担和/或豁免相应的义务。\n            "
                      )
                    ]),
                    _c("li", { staticClass: "item" }, [
                      _vm._v("四、交易管理及费用")
                    ]),
                    _c("li", { staticClass: "item" }, [
                      _vm._v(
                        "\n              1、您同意，本网站有权根据您提供的各项信息及本网站独立获得的信息评定您在本网站所拥有的个人信用等级，\n              或决定是否审核通过您的相关服务或产品申请。"
                      ),
                      _c("br"),
                      _vm._v(
                        "\n              2、本网站有部分产品或服务将根据有关文件、协议和/或本网站页面的相关规则、 产品或服务说明等收取必要的服务或管理费用，其具体内容、比例、\n              金额等事项请参见有关文件及本网站相关页面的规则和产品或服务说明。"
                      ),
                      _c("br"),
                      _vm._v(
                        "\n              3、本网站有权不时调整前述服务或管理费用的类型或金额等，具体修改内容将以本网站页面公布的规则、\n              产品或服务说明为准，如您继续使用本网站服务的，视为您同意上述调整。\n            "
                      )
                    ]),
                    _c("li", { staticClass: "item" }, [_vm._v("五、资金管理")]),
                    _c("li", { staticClass: "item" }, [
                      _vm._v(
                        "\n              针对本网站涉及的金融类服务或产品，本网站提供相应的资金管理服务， 包括但不限于以下内容，具体以当时的服务内容为准："
                      ),
                      _c("br"),
                      _vm._v(
                        "\n              1、就您在本网站进行的借款或出借，本网站和/或本网站委托的第三方机构将为您提供“资金管理服务”，\n              主要包括但不限于：资金的充值、提现、基金份额的划转、代收、代付、查询等。 您可以通过本网站有关页面的具体规则或说明详细了解。"
                      ),
                      _c("br"),
                      _vm._v(
                        "\n              2、上述充值、提现、基金份额的划转、代收、 代付以及查询等服务如涉及本网站或本网站与第三方支付机构或金融机构的合作。 您同意：(a)\n              受第三方支付机构或金融机构可能仅在工作日进行资金代扣及划转的现状等各种原因所限，\n              本网站不对前述服务的资金到账时间做任何承诺，也不承担与此相关的责任，包括但不限于由此产生的利息、 货币贬值等损失；(b)\n              一经您使用前述服务，即表示您不可撤销地授权本网站进行相关操作，且该等操作是不可逆转的，\n              您不能以任何理由拒绝付款或要求取消交易。就前述服务，您应按照有关文件及第三方支付机构或金融机构的规定支付第三方的费用，\n              您与第三方之间就费用支付事项产生的争议或纠纷，与本网站无关。"
                      ),
                      _c("br"),
                      _vm._v(
                        "\n              3、您保证并承诺您通过本网站平台进行交易的资金来源合法。如涉及公安机关、检察机关、法院等司法机关、\n              行政机关、军事机关等权力机关要求协助对您的账户及账户下的经济权益进行查询、冻结或扣划等操作的，\n              本网站将有权配合上述权力机关的操作且不承担对您的任何赔偿责任。"
                      ),
                      _c("br"),
                      _vm._v(
                        "\n              4、本网站有权基于交易安全等方面的考虑不时设定涉及交易的相关事项，包括但不限于交易限额、交易次数等。 您同意，对由此造成的交易不变没有异议。\n            "
                      )
                    ]),
                    _c("li", { staticClass: "item" }, [_vm._v("六、责任限制")]),
                    _c("li", { staticClass: "item" }, [
                      _vm._v(
                        "\n              1、对于您使用本网站服务过程中涉及由第三方提供相关服务的责任由该第三方承担，本网站不承担该等责任。\n              因您自身的原因导致本网站服务无法提供或提供时发生任何错误而产生的任何损失或责任，由您自行负责，本网站不承担责任。"
                      ),
                      _c("br"),
                      _vm._v(
                        "\n              2、在任何情况下，本网站及其股东、创建人、高级职员、董事、代理人、关联公司、母公司、\n              子公司和雇员（以下称“本网站方”）均不以任何明示或默示的方式对您使用本网站服务\n              而产生的任何形式的直接或间接损失承担法律责任，包括但不限于资金损失、利润损失、营业中断损失等。"
                      ),
                      _c("br"),
                      _vm._v(
                        "\n              3、因为本网站或者涉及的第三方网站的设备、系统存在缺陷、黑客攻击、网络故障、电力中断、\n              计算机病毒或其他不可抗力因素造成的损失，本网站均不负责赔偿，您的补救措施只能是与本网站\n              协商终止本协议并停止使用本网站。但是，中国现行法律、法规另有规定的除外。"
                      ),
                      _c("br"),
                      _vm._v(
                        "\n              4、您承诺合法使用本网站提供的服务及网站内容。您不得利用本服务从事侵害他人合法权益之行为，\n              不得在本网站从事任何可能违反中国的法律、法规、规章和政府规范性文件的行为或者任何未经授权的行为。"
                      ),
                      _c("br"),
                      _vm._v(
                        "\n              5、您不得使用本网站提供的服务或其他电子邮件转发服务发出垃圾邮件或其他可能违反本协议的内容。"
                      ),
                      _c("br"),
                      _vm._v(
                        "\n              6、本网站没有义务监测网站内容，但是您确认并同意本网站有权不时地根据法律、法规、政府要求透露、\n              修改或者删除必要的信息，以便更好地运营本网站并保护自身及本网站的其他合法用户。"
                      ),
                      _c("br"),
                      _vm._v(
                        "\n              7、本网站中全部内容的版权均属于本网站所有，该等内容包括但不限于文本、数据、文章、设计、源代码、\n              软件、图片、照片及其他全部信息（以下称“网站内容”）。网站内容受中华人民共和国著作权法\n              及各国际版权公约的保护。未经本网站事先书面同意，您承诺不以任何方式、\n              不以任何形式复制、模仿、传播、出版、公布、展示网站内容，包括但不限于电子的、机械的、复印的、\n              录音录像的方式和形式等。您亦不得将本网站包含的资料等任何内容镜像放到任何其他网站或者服务器。\n              任何未经授权对网站内容的使用均属于违法行为，本网站将追究您的法律责任。"
                      ),
                      _c("br"),
                      _vm._v(
                        "\n              8、由于您违反本协议或任何法律、法规或侵害第三方的权利，而引起第三方对本网站提出的任何形式的索赔、\n              要求、诉讼，本网站有权向您追偿相关损失，包括但不限于本网站的法律费用、名誉损失、及向第三方支付的补偿金等。\n            "
                      )
                    ]),
                    _c("li", { staticClass: "item" }, [_vm._v("七、电子合同")]),
                    _c("li", { staticClass: "item" }, [
                      _vm._v(
                        "\n              1、在本网站平台交易需订立的协议采用电子合同方式，您或您的代理人根据有关协议及本网站的相\n              关规则在本网站确认签署的电子合同即视为您本人真实意愿并以您本人名义签署的合同，具有法律效力。\n              您应妥善保管自己的账户密码等账户信息，不得以账户密码等账户信息被盗用或其他理由否认已订立的 合同的效力或不按照该等合同履行相关义务。"
                      ),
                      _c("br"),
                      _vm._v(
                        "\n              2、您根据本协议以及本网站的相关规则签署电子合同后，不得擅自修改该合同。本网站向您提供电\n              子合同的保管查询、核对等服务，如对电子合同真伪或电子合同的内容有任何疑问，您可通过本网站的相关\n              系统板块查阅有关合同并进行核对。如对此有任何争议，应以本网站记录的合同为准。\n            "
                      )
                    ]),
                    _c("li", { staticClass: "item" }, [
                      _vm._v("八、用户信息及隐私权保护")
                    ]),
                    _c("li", { staticClass: "item" }, [
                      _vm._v("\n              1、用户信息的提供、搜集及核实"),
                      _c("br"),
                      _vm._v(
                        "\n              1.1您有义务在注册时提供自己的真实资料，并保证诸如电子邮件地址、联系电话、联系地址、\n              邮政编码等内容的有效性、安全性和及时更新，以便本网站为您提供服务并与您进行及时、有效的联系。\n              您应完全独自承担因通过这些联系方式无法与您取得联系而导致的您在使用本服务过程 中遭受的任何损失或增加任何费用等不利后果。"
                      ),
                      _c("br"),
                      _vm._v(
                        "\n              1.2本网站可能自公开及私人资料来源收集您的额外资料，以更好地了解本网站用户， 并为其度身订造本网站服务、解决争议和确保在网站进行交易的安全性。\n              本网站仅收集本网站认为就此目的及达成该目的所必须的关于您的个人资料。"
                      ),
                      _c("br"),
                      _vm._v(
                        "\n              1.3您同意本网站可以自行或通过合作的第三方机构对您提交或本网站搜集的用户信息\n              （包括但不限于您的个人身份证信息等）进行核实，并对获得的核实结果根据本协议及有关文件进行查看、使用和留存等操作。"
                      ),
                      _c("br"),
                      _vm._v(
                        "\n              1.4本网站按照您在本网站上的行为自动追踪关于您的某些资料。 本网站利用这些资料进行有关本网站之用户的人口统计、兴趣及行为的内部研究，\n              以更好地了解您以便向您和本网站的其他用户提供更好的服务。"
                      ),
                      _c("br"),
                      _vm._v(
                        "\n              1.5如果您将个人通讯信息（例如：手机短信、电邮或信件）交付给本网站，\n              或如果其他用户或第三方向本网站发出关于您在本网站上的活动或登录事项的通讯信息， 本网站可以将这些资料收集在您的专门档案中。"
                      ),
                      _c("br"),
                      _vm._v("\n              2、用户信息的使用和披露"),
                      _c("br"),
                      _vm._v(
                        "\n              2.1您同意本网站可使用关于您的个人资料（包括但不限于本网站持有的有关您的档案中的资料，\n              及本网站从您目前及以前在本网站上的活动所获取的其他资料）以解决争议、对纠纷进行调停、\n              确保在本网站进行安全交易，并执行本网站的服务协议及相关规则。本网站有时候可能调查多个用\n              户以识别问题或解决争议，特别是本网站可审查您的资料以区分使用多个用户名或别名的用户。\n              为限制在网站上的欺诈、非法或其他刑事犯罪活动，使本网站免受其害，您同意本网站可通过 人工或自动程序对您的个人资料进行评价。"
                      ),
                      _c("br"),
                      _vm._v(
                        "\n              2.2您同意本网站可以使用您的个人资料以改进本网站的推广和促销工作、分析网站的使用率、\n              改善本网站的内容和产品推广形式，并使本网站的网站内容、设计和服务更能符合用户的要求。\n              这些使用能改善本网站的网页，以调整本网站的网页使其更能符合您的需求， 从而使您在使用本网站服务时得到更为顺利、有效、安全及度身订造的交易体验。"
                      ),
                      _c("br"),
                      _vm._v(
                        "\n              2.3您同意本网站利用您的资料与您联络并（在某些情况下）向您传递针对您的兴趣而提供的信息。"
                      ),
                      _c("br"),
                      _vm._v(
                        "\n              2.4本网站对于您提供的、自行收集到的、经认证的个人信息将按照本协议及有关规则予以保护、\n              使用或者披露。本网站将采用行业标准惯例以保护您的个人资料，但鉴于技术限制，\n              本网站不能确保您的全部私人通讯及其他个人资料不会通过本协议中未列明的途径泄露出去。"
                      ),
                      _c("br"),
                      _vm._v(
                        "\n              2.5您使用本网站服务进行交易时，您即授权本公司将您的包括但不限于真实姓名、联系方式、\n              信用状况等必要的个人信息和交易信息披露给与您交易的另一方或本网站的合作机构 （仅限于本网站为完成拟向您提供的服务而合作的机构）。"
                      ),
                      _c("br"),
                      _vm._v(
                        "\n              2.6本网站有义务根据有关法律要求向司法机关和政府部门提供您的个人资料。\n              在您未能按照与本协议、本网站有关规则或者与本网站其他用户签订的有关协议的约定履行自己应尽的义务时\n              （包括但不限于当您作为借款人借款逾期或有其他违约时），本网站有权根据自己的判断、有关协议和规则、\n              国家生效裁决文书或者与该笔交易有关的其他用户的合理请求披露您的个人资料\n              （包括但不限于在本网站及互联网络上公布您的违法、违约行为，并有关将该内容记入任何与您相关的信用资料、\n              档案或数据库），并且作为出借人的其他用户可以采取发布您的个人信息的方式追索债权或通过\n              司法部门要求本网站提供相关资料，本网站对此不承担任何责任。"
                      ),
                      _c("br"),
                      _vm._v("\n              3、您对其他用户信息的使用"),
                      _c("br"),
                      _vm._v(
                        "\n              3.1在本网站提供的交易活动中，您无权要求本网站提供其他用户的个人资料，除非符合以下条件："
                      ),
                      _c("br"),
                      _vm._v(
                        "\n              （1）您已向法院或其他司法机构起诉其他用户的在本网站活动中的违约行为；"
                      ),
                      _c("br"),
                      _vm._v(
                        "\n              （2）与您有关的其他用户逾期未归还借款本息；"
                      ),
                      _c("br"),
                      _vm._v(
                        "\n              （3）本网站被吊销营业执照、解散、清算、宣告破产或者其他有碍于您收回借款本息的情形。"
                      ),
                      _c("br"),
                      _vm._v(
                        "\n              3.2如您通过签署有关协议等方式获得其他用户的个人信息，您同意不将该等个人信息\n              用于除还本付息或向借款人追索债权以外的其他任何用途，除非该等信息根据适用的法律规定、 被有管辖权的法院或政府部门要求披露。\n            "
                      )
                    ]),
                    _c("li", { staticClass: "item" }, [
                      _vm._v("九、协议终止及账户的暂停、注销或终止")
                    ]),
                    _c("li", { staticClass: "item" }, [
                      _vm._v(
                        "\n              1、除非本网站终止本协议或者您申请终止本协议且经本网站同意，否则本协议始终有效。\n              在您违反了本协议、相关规则，或在相关法律法规、政府部门的要求下，本网站有权通过站内短息、\n              电子邮件通知等方式终止本协议、关闭您的账户或者限制您使用本网站。但本网站的终止行为不能\n              免除您根据本协议或在本网站生成的其他协议项下的还未履行完毕的义务。"
                      ),
                      _c("br"),
                      _vm._v(
                        "\n              2、您若发现有第三人冒用或盗用您的用户账户及密码，或其他任何未经合法授权的情形，\n              应立即以有效方式通知本网站，要求本网站暂停相关服务，否则由此产生的一切责任由您本人承担。\n              同时，您理解本网站对您的请求采取行动需要合理期限，在此之前，本网站对第三人使用该服务所导致的损失不承担任何责任。"
                      ),
                      _c("br"),
                      _vm._v(
                        "\n              3、您决定不再使用用户账户时，应首先清偿所有应付款项（包括但不限于借款本金、利息、罚息、\n              违约金、服务费、管理费等），再将用户账户中的可用款项（如有）全部提现或者向本网站发出其它合法的支付指令，\n              并向本网站申请注销该用户账户，经本网站审核同意后可正式注销用户账户。会员死亡或被宣告死亡的，\n              其在本协议项下的各项权利义务由其继承人承担。若会员丧失全部或部分民事权利能力或民事行为能力，\n              本网站有权根据有效法律文书（包括但不限于生效的法院判决等）或其法定监护人的指示处置与用户账户相关的款项。"
                      ),
                      _c("br"),
                      _vm._v(
                        "\n              4、本网站有权基于单方独立判断，在认为可能发生危害交易安全等情形时，不经通知而先行暂停、\n              中断或终止向您提供本协议项下的全部或部分会员服务，并将注册资料移除或删除， 且无需对您或任何第三方承担任何责任。前述情形包括但不限于："
                      ),
                      _c("br"),
                      _vm._v(
                        "\n              （1）本网站认为您提供的个人资料不具有真实性、有效性或完整性；"
                      ),
                      _c("br"),
                      _vm._v(
                        "\n              （2）本网站发现异常交易或有疑义或有违法之虞时；"
                      ),
                      _c("br"),
                      _vm._v(
                        "\n              （3）本网站认为您的账户涉嫌洗钱、套现、传销、被冒用或其他本网站认为有风险之情形；"
                      ),
                      _c("br"),
                      _vm._v(
                        "\n              （4）您存在违背社会公序良俗行为的；"
                      ),
                      _c("br"),
                      _vm._v(
                        "\n              （5）本网站认为您已经违反本协议中规定的各类规则及精神；"
                      ),
                      _c("br"),
                      _vm._v(
                        "\n              （6）对于网络设备进行必要的保养与施工时；"
                      ),
                      _c("br"),
                      _vm._v(
                        "\n              （7）突发网络设备故障或因其他不明原因导致无法提供服务的；"
                      ),
                      _c("br"),
                      _vm._v("\n              （8）政府机关等权力机构要求的；"),
                      _c("br"),
                      _vm._v(
                        "\n              （9）本网站基于交易安全等原因，根据其单独判断需先行暂停、中断或终止向您提供本\n              协议项下的全部或部分会员服务，并将注册资料移除或删除的其他情形。"
                      ),
                      _c("br"),
                      _vm._v(
                        "\n              5、您同意在必要时，本网站无需进行事先通知即有权终止提供用户账户服务，并可能立即暂停、\n              关闭或删除您的用户账户及该用户账户中的所有相关资料及档案，并将您滞留在这些账户的全部合法资金退回到您的银行账户。"
                      ),
                      _c("br"),
                      _vm._v(
                        "\n              6、用户账户的暂停、中断或终止不代表您责任的终止，您仍应对您使用本网站服务期间的\n              行为承担可能的违约或损害赔偿责任，同时本网站仍可保有您的相关信息。\n            "
                      )
                    ]),
                    _c("li", { staticClass: "item" }, [_vm._v("十、通知")]),
                    _c("li", { staticClass: "item" }, [
                      _vm._v(
                        "\n              本协议项下的通知如以公示方式作出，一经在本网站公示即视为已经送达。除此之外，\n              其他向您个人发布的具有专属性的通知将由本网站向您在注册时提供的电子邮箱，\n              或本网站在您的个人账户中为您设置的站内消息系统栏，或您在注册后在本网站绑定的手机发送， 一经发送即视为已经送达。请您密切关注您的电子邮箱\n              、站内消息系统栏中的邮件、 信息及手机中的短信信息。您同意本网站出于向您提供服务之目的，可以向您的电子邮箱、\n              站内消息系统栏和手机发送有关通知或提醒；若您不愿意接收，请在本网站相应系统板块进行设置。\n              但您同时同意并确认，若您设置了不接收有关通知或提醒，则您有可能收不到该等通知信息， 您不得以您未收到或未阅读该等通知信息主张相关通知未送达于您。\n            "
                      )
                    ]),
                    _c("li", { staticClass: "item" }, [
                      _vm._v("十一、 适用法律和管辖")
                    ]),
                    _c("li", { staticClass: "item" }, [
                      _vm._v(
                        "因本网站所提供服务而产生的争议均适用中华人民共和国法律， 并由本网站经营者住所地的人民法院管辖。"
                      )
                    ]),
                    _c("li", { staticClass: "item" }, [
                      _vm._v("十二、风险提示说明")
                    ]),
                    _c("li", { staticClass: "item" }, [
                      _vm._v(
                        "\n              通过本网站进行的各类交易并不能规避商务及法律风险， 本网站不对您在本网站的任何交易提供明示或默示的担保，\n              您应知悉交易存在的风险并独立做出判断后做出交易决策， 同时对交易产生的风险承担责任。\n            "
                      )
                    ]),
                    _c("li", { staticClass: "item" }, [
                      _vm._v("十三、特别约定")
                    ]),
                    _c("li", { staticClass: "item" }, [
                      _vm._v(
                        "\n              如您接受与农信互联具有投资关系的关联企业通过本网站向您提供产品或服务的， 本协议将对您和农信互联的关联企业具有同样约束力，\n              即无需关联企业与您重新签署相关协议，关联企业即享有与本协议约定的农信互联相同的权利。\n            "
                      )
                    ]),
                    _c("li", { staticClass: "item" }, [
                      _vm._v("十四、咨询、投诉")
                    ]),
                    _c("li", { staticClass: "item" }, [
                      _vm._v(
                        "\n              本网站充分尊重您的合法权益，本协议以及本网站上发布的各类规则、 声明等内容，均是为了更好地为您提供服务，如您在使用本网站过程中有任何疑问或投诉，\n              可随时致电客服热线：4008105353，本网站欢迎您提出意见和建议， 并虚心接收与适时完善本协议及本网站的各类规则。\n            "
                      )
                    ]),
                    _c("li", { staticClass: "item" }, [_vm._v("十五、其他")]),
                    _c("li", { staticClass: "item" }, [
                      _vm._v(
                        "\n              1、本网站对本协议拥有最终的解释权。本协议及本网站有关页面的相关名词可互相引用参照，\n              如有不同理解，则以本协议条款为准。此外，若本协议的部分条款被认定为无效或者无法实施时， 本协议中的其他条款仍然有效。"
                      ),
                      _c("br"),
                      _vm._v(
                        "\n              2、本协议中以加粗方式显著标识的条款，请您着重阅读并认真理解，如有任何疑问，\n              请务必通过本协议第十三条公布的联系方式进行咨询，否则视为您已经知悉并理解上述条款内容，同时接受上述条款内容的约束。\n            "
                      )
                    ])
                  ])
                ])
              ])
            ]
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }